<template>
  <div class="col-sm-12 col-md-12 mb-3">
    <label for="recipient-name" class="form-label fw-bold blue" v-if="!readOnly">{{module + " " + idx}}</label>
    <list-item>
      <template v-slot:title>
        <div class="row w-100">
          <div class="col-sm-12 col-md-6 mb-3">
            <label for="recipient-name" class="form-label">De</label>
            <input type="datetime-local" class="form-control" v-model="startDate">
            <label for="recipient-name" class="form-label mb-0 blue">{{formatDateTimeToExtense(startDate)}}</label>
          </div>
          <div class="col-sm-12 col-md-6 mb-3">
            <label for="recipient-name" class="form-label">Ás</label>
            <input type="datetime-local" class="form-control" v-model="endDate">
            <label for="recipient-name" class="form-label mb-0 blue">{{formatDateTimeToExtense(endDate)}}</label>
          </div>
        </div>
      </template>
      <template v-slot:info v-if="!readOnly">
        <div class="d-flex h-100">
          <font-awesome-icon class="red pointer" icon="trash" v-on:click="emitDelete" />
        </div>
      </template>
    </list-item>
  </div>
</template>

<script>
import {formatDateTimeToExtense,} from "../../services/formatters";
import timeMixins from "../../services/time";
import ListItem from "../ListGroup/ListItem.vue";

export default {
    name: "SchedulingDatesInput",
    mixins: [timeMixins],
    components: {  
      ListItem
    },
    props: {
        idx: {
          type: Number
        },
        module: {
          type: String
        },
        iniStartDate: {
          type: String
        },
        iniEndDate: {
          type: String
        },
        readOnly: {
          type: Boolean
        }
    },
    emits: ["value-obj", "delete"],

  async mounted() {
    this.fillData();
  },

  async updated() {
    this.fillData();
  },
  data() {
    return {
      startDate: "",
      endDate: ""
    };
  },
  methods: {
    defineEndDate() {
        if (!this.startDate) {
            return;
        }
        this.endDate = this.addHours(this.startDate, 1);
        this.emitMyself();
      },
    emitMyself() {
        this.$emit("value-obj", { idx: this.idx, startDate: this.startDate, endDate: this.endDate });
      },
    emitDelete() {
      this.$emit("delete", this.idx)
    },
    fillData() {
      if (this.iniStartDate && this.iniEndDate) {
        this.startDate = this.iniStartDate;
        this.endDate = this.iniEndDate;
      }
    },
    formatDateTimeToExtense
  },
  watch: {
      "startDate"(newVal) {
          if (!newVal) {
              this.endDate = "";
          }
          this.defineEndDate();
      },
    "endDate"() {
        this.emitMyself();
    }
  },
}
</script>

<style lang="css" scoped>
    @import'../../assets/css/_colors';
    @import'../../assets/css/_schedulings';
</style>
